import { motion } from "framer-motion";

const initial = { opacity: 0, y: 30 };
const whileInView = { opacity: 1, y: 0 };
const viewport = { once: true, margin: "-80px" };
const easing = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y, className = "" }) => {
  const fromY = y === undefined ? initial.y : y;
  return (
    <motion.div
      initial={y === undefined ? initial : { opacity: 0, y: fromY }}
      whileInView={whileInView}
      viewport={viewport}
      transition={{ duration: 0.8, delay, ease: easing }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
